export default {"src":"/_next/static/media/check.5c7809b4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};